import React from 'react';

import { BUSINESS_TOOL_SUB_SECTIONS } from 'constants/businessTool';
import { useBusinessToolStore } from 'store/useBusinessToolStore';
import { getActiveSubSection } from 'store/useBusinessToolStore/selectors';

import { IForBankFormSubSections } from 'components/BusinessToolForm/Sections/forBankSections';

import { MarketingPlan } from './MarketingPlan';
import { SalesPlanSection } from './SalesPlanSection';

const SUB_SECTIONS: IForBankFormSubSections = {
  [BUSINESS_TOOL_SUB_SECTIONS.MARKETING_AND_SALES.SALES_PLAN]: SalesPlanSection,
  [BUSINESS_TOOL_SUB_SECTIONS.MARKETING_AND_SALES.MARKETING_PLAN]: MarketingPlan,
};

export const MarketingAndSales: React.FC = () => {
  const activeSubSection = useBusinessToolStore(getActiveSubSection);

  if (!activeSubSection) {
    return null;
  }

  const ActiveComponent = SUB_SECTIONS?.[activeSubSection] || null;

  if (ActiveComponent) {
    return <ActiveComponent />;
  }

  return null;
};
